import React, { useContext, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "../Contexts/AuthContext";
import CryptoJS from "crypto-js";

const PrivateRoute = ({
  component: Component,
  layout: Layout,
  parentRoute,
  parentName,
  currentRoute,
  currentName,
  show,
  ...rest
}) => {
  const { isAuth } = useContext(AuthContext);

  let checkAuth;
  try {
    checkAuth = CryptoJS.AES.decrypt(
      isAuth,
      process.env.REACT_APP_HASH_KEY
    ).toString(CryptoJS.enc.Utf8);
  } catch {
    checkAuth = false;
  }

  useEffect(() => {
    document.body.id = "";
  }, []);

  return (
    <Route
      {...rest}
      render={props =>
        checkAuth === "true" ? (
          <Layout
            parentName={parentName}
            parentRoute={parentRoute}
            currentName={currentName}
            show={show}
          >
            <Component {...props} />
          </Layout>
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default PrivateRoute;
